import axios from 'axios';

const API_URL = localStorage.getItem('countryBackendUrl')

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    // 'ngrok-skip-browser-warning': true,
  },
});

axiosInstance.interceptors.request.use((config) => {
  const countryName = localStorage.getItem('countryName');
  if (countryName) {
    config.headers['X-Country'] = countryName;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default axiosInstance;
